import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getOrders(params: any): AxiosPromise {
    return EndPointService.get('/orders', { params });
}

function getOrder(id: number | string): AxiosPromise {
    return EndPointService.get(`/orders/${id}`);
}

function createOrderDoc(data: any, id: string | number): AxiosPromise {
    return EndPointService.post(`/orders/upload-order-doc`, data, { params: { id } });
}

function deleteOrder(id: number | string): AxiosPromise {
    return EndPointService.delete(`/orders/${id}`);
}

function createOrder(payload: any): AxiosPromise {
    return EndPointService.post('/orders', payload);
}

function deleteFileOrder(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/order_docs/${fileId}`);
}

function createFilesOrder(data: any): AxiosPromise {
    return EndPointService.post(`/order_docs`, data);
}

function getFilesOrder(id: string | number): AxiosPromise {
    return EndPointService.get(`/order_docs`, {
        params: {
            'order.id': id,
        },
    });
}

function updateOrder(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/orders/${id}`, { ...payload });
}

export default {
    getOrders,
    getFilesOrder,
    createFilesOrder,
    createOrderDoc,
    deleteFileOrder,
    getOrder,
    deleteOrder,
    createOrder,
    updateOrder,
};
